import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Col,
  Input,
  InputGroup,
  Row,
} from "reactstrap";
import ExpandIcon from "../../../assets/icon/expand.svg";
import addIcon from "../../../assets/icon/add-icon.svg";
import cancelIcon from "../../../assets/icon/cancel-icon.svg";
import MinimizeIcon from "../../../assets/icon/minimize.svg";
import iconStatus from "../../../assets/icon/status-save-icon.svg";
import { useNavigate } from "react-router-dom";
import plusIcon from "../../../assets/icon/plus-icon-add-note.svg";

const ClaimsInfo = ({ gotoMainPath }) => {
  const [open, setOpen] = useState(false);
  const [expand, setExpand] = useState(false);

  const [data, setData] = useState({
    one: "",
    two: "",
    three: "",
    four: "",
  });

  const [todosOne, setTodosOne] = useState([]);
  const [todosTwo, setTodosTwo] = useState([]);
  const [todosThree, setTodosThree] = useState([]);
  const [todosFour, setTodosFour] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = (field) => {
    const newEntry = { id: Date.now(), value: data[field] };

    switch (field) {
      case "one":
        if (data.one !== "") {
          setTodosOne([...todosOne, newEntry]);
        }
        break;
      case "two":
        if (data.two !== "") {
          setTodosTwo([...todosTwo, newEntry]);
        }
        break;
      case "three":
        if (data.three !== "") {
          setTodosThree([...todosThree, newEntry]);
        }
        break;
      case "four":
        if (data.four !== "") {
          setTodosFour([...todosFour, newEntry]);
        }
        break;
      default:
        break;
    }

    setData({ ...data, [field]: "" });
  };

  const handleDelete = (id, field) => {
    switch (field) {
      case "one":
        setTodosOne(todosOne.filter((item) => item.id !== id));
        break;
      case "two":
        setTodosTwo(todosTwo.filter((item) => item.id !== id));
        break;
      case "three":
        setTodosThree(todosThree.filter((item) => item.id !== id));
        break;
      case "four":
        setTodosFour(todosFour.filter((item) => item.id !== id));
        break;
      default:
        break;
    }
  };

  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  const boxHeading = [
    {
      id: 1,
      heading: "Claim Rejected",
      headingTwo: "Pend Order",
      subHeader: "Refill too soon",
      color: "#F8CFCF",
      headColor: "#E54141",
      fontWeight: 600,
      desColor: "#757575",
      borderColor: "2px solid #E54141",
      message: "",
      message2: "Next fill date: 1/27/2024",
    },
    {
      id: 2,
      heading: "Primary Insurance",
      headingTwo: "",
      subHeader: "",
      color: "#CFDCF8",
      headColor: "#419BE5",
      desColor: "#4175E5",
      borderColor: "2px solid #419BE5",
      message: "BIN: 123456",
      message2: "PCN: ABCDE",
      message3: "Group: RETAIL",
    },
  ];

  return (
    <div
      className="d-flex flex-column bg-white align-items-end"
      style={{
        width: expand ? "81vw" : "50vw",
        backgroundColor: "white",
        height: "100vh",
      }}
    >
      <div className="cliamsexpand-btn" onClick={() => setExpand(!expand)}>
        <img src={expand ? MinimizeIcon : ExpandIcon} alt="not available" />
        {expand ? "Collapse" : "Expand Details"}
      </div>
      <div style={{ padding: "8px", width: expand ? "81vw" : "50vw" }}>
        {boxHeading.map((name) => (
          <div
            className="claimsHeading"
            style={{
              backgroundColor: name.color,
              border: name.borderColor,
            }}
          >
            <div className="headerText">
              <div
                style={{
                  color: name.headColor,
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                {name.heading}
              </div>
              <div className="headTwo">{name.headingTwo}</div>
            </div>
            <div className="claimsSubHeader" style={{ color: name.headColor }}>
              {name.subHeader}
            </div>
            <div
              style={{
                color: name.desColor,
                fontSize: "12px",
                fontWeight: 500,
                paddingRight: "15px",
              }}
            >
              {name.message} <br />
              {name.message2} <br />
              {name.message3}
            </div>
          </div>
        ))}
      </div>
      <div
        style={{ width: !expand ? "48.5vw" : "79.5vw", marginRight: "10px" }}
      >
        <Accordion className="" open={open} toggle={toggle}>
          <AccordionItem className="mb-2">
            <AccordionHeader targetId="1">
              Submission Clarification Codes{" "}
            </AccordionHeader>
            <AccordionBody
              accordionId="1"
              style={{ backgroundColor: "#F7F7F7" }}
            >
              <InputGroup className="inputGrp">
                <Input
                  className="inputText"
                  id="clamsone"
                  name="one"
                  type="text"
                  value={data.one}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,2}$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  placeholder="Enter to Add SCC"
                  autoComplete="off"
                />
                <img
                  className="cursor-pointer"
                  onClick={() => {
                    handleSubmit("one");
                  }}
                  src={addIcon}
                  alt="not available"
                />{" "}
              </InputGroup>
              <div className="d-flex align-items-center overflow-auto">
                <div className="dataBox">
                  20-340B <img src={cancelIcon} alt="not available" />
                </div>
                {todosOne.map((name, index) => (
                  <div key={name.id} className="dataBox">
                    {name.value}{" "}
                    <img
                      className="cursor-pointer"
                      onClick={() => handleDelete(name.id, "one")}
                      src={cancelIcon}
                      alt="not available"
                    />
                  </div>
                ))}
              </div>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem className="mb-2">
            <AccordionHeader targetId="2">DUR Override Codes</AccordionHeader>
            <AccordionBody
              accordionId="2"
              style={{ backgroundColor: "#F7F7F7" }}
            >
              <InputGroup className="inputGrp">
                <Input
                  className="inputText"
                  id="clamstwo"
                  name="two"
                  type="text"
                  value={data.two}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,2}$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  placeholder="Enter to Add DUR"
                  autoComplete="off"
                />
                <img
                  onClick={() => {
                    handleSubmit("two");
                  }}
                  src={addIcon}
                  alt="not available"
                />{" "}
              </InputGroup>
              <div className="d-flex align-items-center overflow-auto">
                <div className="dataBox">
                  20-340B <img src={cancelIcon} alt="not available" />
                </div>
                {todosTwo.map((name, index) => (
                  <div key={name.id} className="dataBox">
                    {name.value}{" "}
                    <img
                      onClick={() => handleDelete(name.id, "two")}
                      src={cancelIcon}
                      alt="not available"
                    />
                  </div>
                ))}
              </div>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem className="mb-2">
            <AccordionHeader targetId="3">Other Coverage Codes</AccordionHeader>
            <AccordionBody
              accordionId="3"
              style={{ backgroundColor: "#F7F7F7" }}
            >
              <InputGroup className="inputGrp">
                <Input
                  className="inputText"
                  id="clamsthree"
                  name="three"
                  color="red"
                  type="text"
                  value={data.three}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,2}$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  placeholder="Enter to Add OCC"
                  autoComplete="off"
                />
                <img
                  onClick={() => {
                    handleSubmit("three");
                  }}
                  src={addIcon}
                  alt="not available"
                />{" "}
              </InputGroup>
              <div className="d-flex align-items-center overflow-auto">
                <div className="dataBox">
                  20-340B <img src={cancelIcon} alt="not available" />
                </div>
                {todosThree.map((name, index) => (
                  <div key={name.id} className="dataBox">
                    {name.value}{" "}
                    <img
                      onClick={() => handleDelete(name.id, "three")}
                      src={cancelIcon}
                      alt="not available"
                    />
                  </div>
                ))}
              </div>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem className="mb-2">
            <AccordionHeader targetId="4">Claims Summary</AccordionHeader>
            <AccordionBody
              accordionId="4"
              style={{ backgroundColor: "#F7F7F7" }}
            >
              <InputGroup className="inputGrp">
                <Input
                  className="inputText"
                  id="clamsfour"
                  name="four"
                  type="text"
                  value={data.four}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,2}$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  placeholder="Enter to Add CS"
                  autoComplete="off"
                />
                <img
                  onClick={() => {
                    handleSubmit("four");
                  }}
                  src={addIcon}
                  alt="not available"
                />{" "}
              </InputGroup>
              <div className="d-flex align-items-center overflow-auto">
                <div className="dataBox">
                  20-340B <img src={cancelIcon} alt="not available" />
                </div>
                {todosFour.map((name, index) => (
                  <div key={name.id} className="dataBox">
                    {name.value}{" "}
                    <img
                      onClick={() => handleDelete(name.id, "four")}
                      src={cancelIcon}
                      alt="not available"
                    />
                  </div>
                ))}
              </div>
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </div>
      <div
        className="cliams-footer p-3"
        style={{
          width: expand ? "80vw" : "50vw",
          height: "64px",
        }}
      >
        <div
          style={{
            color: "#702C62",
            fontSize: "16px",
            fontWeight: 600,
          }}
          className="d-flex justify-content-center align-items-center gap-2"
        >
          <img src={plusIcon} />
          <>Add to Prescriber Calls</>
        </div>
        <div className="d-flex">
          <Button>Start P/A</Button>
          <Button color="primary" onClick={gotoMainPath}>
            Resubmit Claim
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ClaimsInfo;
